import { NAME, UNIT_SELECTION } from './constants'
import R from 'ramda'
import jwtDecode from 'jwt-decode'
import { fromNullable } from 'data.maybe'
import moment from 'moment'
import { getEffectiveJwt, getMetaConfig } from 'utils'
const getState = state => state[NAME]

// no longer get JWT from redux bcoz if cookie deleted
// than still other tab get JWT from redux,
// so jwt only get it from cookie only

export const getApiTargetInfo = state => {
  const reduxApiTargetInfo = R.compose(
    state => state.apiTargetInfo,
    getState
  )(state)
  const effJWT = getEffectiveJwt()
  reduxApiTargetInfo.jwt = effJWT
  // return { ...reduxApiTargetInfo, jwt: effJWT }
  return reduxApiTargetInfo
}

export const getTransDate = R.compose(state => state.transDate, getState)
export const getEndDate = R.compose(state => state.endDate, getState)
export const getUnits = R.compose(state => state.units, getState)
export const getUnitTypeCode = R.compose(state => state.unitTypeCode, getState)
export const getUnitNameMap = R.compose(state => state.unitNameMap, getState)
export const getUnitGroups = R.compose(state => state.unitGroups, getState)
export const getHrsInDay = R.compose(state => state.hrsInDay, getState)
export const getFilteredUnitIds = R.compose(
  state => state.filteredUnits,
  getState
)
export const getFilteredUnits = state => {
  const unitIds = getFilteredUnitIds(state)
  const units = getUnits(state)
  return units.filter(u => unitIds.includes(u.unitId))
}

export const getFuzzyStr = R.compose(state => state.fuzzyStr, getState)
export const getFilteredUnitGroup = R.compose(
  state => state.filteredUnitGroup,
  getState
)
export const getEventTypes = R.compose(state => state.eventTypes, getState)
export const getStations = R.compose(state => state.station, getState)
export const getFailCode = R.compose(state => state.failCode, getState)
export const getAmlificationCode = R.compose(
  state => state.amplification,
  getState
)
export const getStationsNameMap = R.compose(
  state =>
    R.compose(
      R.fromPairs,
      R.map(a => [a.station, a.stationName])
    )(state.station),
  getState
)
export const getReportNameMap = R.compose(
  state => state.reportNameMap,
  getState
)

export const getReportDisplayCodeMap = R.compose(
  state => state.reportDisplayCodeMap,
  getState
)

export const getUtilityStationMap = curState => {
  const units = R.compose(state => state.units, getState)(curState)

  const us = {}
  units.forEach(f => {
    const c = us[f.utility] || []
    if (!c.includes(f.station)) {
      c.push(f.station)
      us[f.utility] = c
    }
  })
  return us
}
export const getStationUtilityMap = curState => {
  const units = R.compose(state => state.units, getState)(curState)
  const st = R.compose(
    R.reduce((a, b) => ({ ...a, ...b }), {}),
    R.map(([a, b]) => ({ [a]: R.uniq(b.map(z => z.val)) })),
    R.toPairs,
    R.groupBy(u => u.key),
    R.map(u => ({ key: u.station, val: u.utility })),
    R.filter(u => u.station !== undefined)
  )(units)
  return st
}
export const getPnodeZoneEffective = R.compose(
  state => state.pnodeZoneEffective || [],
  getState
)
// this is from causecode
export const getCauseCodeData = R.compose(
  state => state.causeCodeData,
  getState
)
export const getCauseCodeMap = curState => {
  return R.compose(
    R.fromPairs,
    R.map(a => [a.causeCode, a.description]),
    state => state.causeCodeData,
    getState
  )(curState)
}
export const getCauseCodeOmcMap = curState => {
  return R.compose(
    R.fromPairs,
    R.map(a => [a.causeCode, a.omc === 'Y']),
    state => state.causeCodeData,
    getState
  )(curState)
}
export const getUserInfo = R.compose(state => state.userInfo, getState)
export const getUserName = R.compose(
  state => (state.userInfo || {}).userName,
  getState
)
export const getLoadingInitDataStatus = R.compose(
  state => state.loadingInitData,
  getState
)
export const getLoadingDateDataStatus = R.compose(
  state => state.loadingUnits,
  getState
)
const findUnitGroup = (groups, value) =>
  R.find(({ name }) => name === value, groups)

// export const getUnitCodeCauseCodeMap = R.compose(state => state.unitCodeCauseCodeMap, getState)
// export const getUnitCodeCauseCodeMap = state => {
//   const causeCodeList = R.compose(state => state.causeCode, getState)(state)
//   return R.pipe(
//     R.groupBy(r => r.unitCode),
//     R.map(R.groupBy(r => r.system)),
//     R.map(R.map(R.groupBy(r => r.component)))
//   )(causeCodeList)
// }

export const getUnitFilterInfo = state => ({
  fuzzyStr: getFuzzyStr(state),
  unitNameMap: getUnitNameMap(state),
  unitsInGroup: fromNullable(
    findUnitGroup(getUnitGroups(state), getFilteredUnitGroup(state))
  )
    .map(g => g.units)
    .getOrElse(undefined),
})

export const getEnvConfig = R.compose(s => s.envConfig, getState)
export const getClientInfo = R.compose(
  s => s.envConfig.clientId || 'INTEG',
  getState
)
export const getUserIdleLogoutMinute = R.compose(
  s => s.envConfig.userIdleLogoutMinutes || -1,
  getState
)
export const getLdapUserNameEnabled = R.compose(
  s => s.envConfig.ldapEnabled || false,
  getState
)

export const getValidYearRange = R.compose(s => {
  const validYear = s.envConfig.validYearRange || '10'
  return parseInt(validYear)
}, getState)

export const isStackTraceAllowed = R.compose(s => {
  const isStackTraceAllowed = s.envConfig.isStackTraceAllowed
  if (
    isStackTraceAllowed === undefined ||
    R.isNil(isStackTraceAllowed) ||
    isStackTraceAllowed === true ||
    isStackTraceAllowed === 'true'
  )
    return true
  else return false
}, getState)

const useMisoF5 = getMetaConfig('misoF5Auth', 'false') === 'true'

const isJwtDataExpired = jwtData =>
  !useMisoF5 &&
  jwtData &&
  jwtData.exp &&
  moment(jwtData.exp * 1000).isBefore(moment())

// export const isExpiredJWTData = state=>{
//   const validJwtData=jwtDecode(state.apiTargetInfo)

//   return isJwtDataExpired(validJwtData)
// }

export const isExpiredJWTData = useMisoF5
  ? () => false
  : // eslint-disable-next-line no-unused-vars
    R.compose(() => {
      try {
        return fromNullable(getEffectiveJwt())
          .map(jwtDecode)
          .map(j => {
            return j
          })
          .map(isJwtDataExpired)
          .getOrElse(true)
      } catch (e) {
        /* eslint-disable no-console */
        console.log(e)
        console.log(e.stack)
        /* eslint-enable no-console */
        return true
      }
    }, getApiTargetInfo)

// eslint-disable-next-line no-unused-vars
export const isAuthenticated = useMisoF5
  ? () => true
  : R.compose(() => {
      try {
        return fromNullable(getEffectiveJwt())
          .map(jwtDecode)
          .chain(t => fromNullable(t.roles))
          .chain(roles => fromNullable(roles.pgads))
          .map(pgads => pgads.includes('user'))
          .getOrElse(false)
      } catch (e) {
        /* eslint-disable no-console */
        console.log(e)
        console.log(e.stack)
        /* eslint-enable no-console */
        return false
      }
    }, getApiTargetInfo)

// when call this method , pls check for CHANGE_PERMISSIONS
// but  DB knows only admin' from usertable so not call CHANGE_PERMISSIONS
export const isAdminType = R.compose(
  state => state.userInfo.userType === 'ADMIN',
  getState
)

export const getCompanyNameMap = R.compose(
  state => state.companyNameMap,
  getState
)
export const getLoginError = R.compose(state => state.loginError, getState)
export const getTwoFactorRegistration = R.compose(
  state => state.twoFactorRegistration,
  getState
)
export const getTwoFactorRequired = R.compose(
  state => state.twoFactorCodeRequired,
  getState
)

export const getTwoFactorOptions = R.compose(
  state => state.twoFactorOptions,
  getState
)

export const getUserRoles = R.compose(state => state.userRoles, getState)
// export const getPermitActions = R.compose(state => state.permitActionList, getState)
export const getPermitActions = R.compose(state => {
  const act = R.compose(
    R.uniq,
    R.flatten,
    R.map(r => r.actions)
  )(state.userRoles)

  return act
}, getState)

// export const getUserReport = R.compose(state => state.userReport, getState)
export const getUserReport = R.compose(state => {
  return R.compose(
    R.uniq,
    R.flatten,
    R.map(r => r.resources.report || [])
  )(state.userRoles)
}, getState)

export const getUserCompany = R.compose(state => {
  return R.compose(
    R.uniq,
    R.flatten,
    R.map(r => r.resources.company || [])
  )(state.userRoles)
}, getState)

export const getUserStation = R.compose(state => {
  return R.compose(
    R.uniq,
    R.flatten,
    R.map(r => r.resources.station || [])
  )(state.userRoles)
}, getState)

export const getUserRoleType = R.compose(state => {
  const act = R.compose(
    R.uniq,
    R.flatten,
    R.map(r => r.shiftList)
  )(state.userRoles)

  return act
}, getState)

export const getUtilityUnitsMap = curState => {
  return R.compose(
    R.fromPairs,
    // R.map(([k, v]) => [k, R.uniq(v)]),
    R.map(([k, v]) => [k, R.uniq(v.map(v => v.unitId))]),
    R.toPairs,
    R.groupBy(d => d.utility),
    R.map(({ unitId, utility }) => ({ unitId, utility })),
    state => state.units,
    getState
  )(curState)
}
export const getUtilities = R.compose(state => state.utilities, getState)
export const getUtilityNameMap = R.compose(state => {
  const d = R.compose(
    R.fromPairs,
    R.map(a => [a.utility, a.utilityName])
  )(state.utilities)

  return d
}, getState)
export const getCompanyUtilityMap = curState => {
  // R.compose(  state => state.companyUtilityMap,  getState)
  return R.compose(
    v => R.mapObjIndexed((n, k) => R.map(s => s.utility, v[k]))(v),
    R.groupBy(c => c.companyId),
    state => state.utilities,
    getState
  )(curState)
}
export const getSecurityInfo = state => ({
  jwt: fromNullable(getEffectiveJwt())
    // .map(info => info.jwt)
    .getOrElse(null),
  isGodMode: getEnvConfig(state).authGodMode,
})

const getUnitSelectionState = state => state[UNIT_SELECTION]

export const getSelectedUnits = R.compose(
  state => state.selectedUnit,
  getUnitSelectionState
)

export const isUnitLoading = state => state.loadingUnits

export const getContribOperCondition = R.compose(
  state => state.contribConditionList,
  getState
)

export const getContribOperConditionMap = R.compose(state => {
  return R.compose(
    R.fromPairs,
    R.map(({ code, description }) => [code, description])
  )(state.contribConditionList)
}, getState)
